import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Pagination, Form, Input } from 'antd'
import UploadVideo from '../../commponents/video/index';
import './index.less'
const FormItem = Form.Item

class BootVedio extends Component{
  constructor(props) {
		super(props)
		this.state = {
			total: 0,
			vedioId: '',
      pageNum: 1,
      pageSize: 10,
      videoName: '',
			modelTitle: '新增',
			visible: false,
			releaseVisible: false,
      qiuniuUrl: '',
      vedioListData: [],
      bootVideo: {},
      swiperId: '',
      columns: [{
        title: '名称',
        dataIndex: 'videoName',
        key: 'videoName',
        align: 'center'
      },{
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center'
      },
      {
        title: '操作',
        key: 'operation',
        align: 'center',
        render: (record) => <div>
          <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
            this.setState({
              swiperId: record.id,
              visible: true,
              modelTitle: '编辑',
              videoName: record.videoName,
              introduce: record.introduce,
              subjectform: record.subjectId,
              presetNum: record.presetNum||0,
              
              bootVideo: {
                uid: record.uploadUid,
                type: record.uploadType||'',
                url: record.videoUrl,
                name: record.videoName
              },
            })
          }}>编辑</span>
          <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
            Modal.confirm({
              title: '删除操作',
              okText: "确认",
              cancelText: "取消",
              content: (
                <div>
                  <p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
                </div>
              ),
              onOk: () => {
                this.delSwiper(record.id)
              },
            });
          }}>删除</span>
          </div>
      }]
    }
  }
  vedioInit = () => {
    axios.post('/bootcampVideo/list', {bootCampId: this.state.vedioId,pageNum: this.state.pageNum,pageSize: this.state.pageSize}).then(res => {
      if(res.data.code === '200'){
        this.setState({
          vedioListData: res.data.data.list,
          total: res.data.data.total
        })
      }
    })
  }
  onShowSizeChange = (current,pageSize) => {
    this.setState({
      pageNum: 1,
      pageSize: pageSize
    },()=> {
      this.vedioInit()
    })
  }

  handleOk = ()=> {
    // console.log('chakan',this.state.qiuniuUrl)
		this.props.form.validateFields((err, values) => {
      console.log(values)
			if(!err) {
				if(this.state.modelTitle === '新增'){
          axios.post('/bootcampVideo/add',{
            videoName: values.videoName,
            bootCampId: this.state.vedioId,
            videoUrl: this.state.qiuniuUrl,    //+'/'+ values.bootVideo[0].response.key,
            uploadUid: values.bootVideo[0].uid,
          }).then(res => {
            if (res.data.code === '200') {
							message.success('添加成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.vedioInit()
						}
          })
        }else{
          //let pic = values.bootVideo.url && values.bootVideo.url?values.bootVideo.url:this.state.qiuniuUrl+'/'+values.bootVideo.response.key
          let pic = values.bootVideo.url ? values.bootVideo.url : this.state.qiuniuUrl
          axios.post('/bootcampVideo/update',{
            id: this.state.swiperId,
            videoName: values.videoName,
            bootCampId: this.state.vedioId,
            videoUrl: pic,
            uploadUid:this.state.swiperId && values.bootVideo.uid ?  values.bootVideo.uid : values.bootVideo[0].uid,
          }).then(res => {
            if (res.data.code === '200') {
							message.success('修改成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.vedioInit()
						} 
          })
        }
      }
    })
  }
  delSwiper = (id) => {
    axios.get(`/bootcampVideo/del/${id}`).then(res => {
      if(res.data.code === '200'){
        message.success('删除成功')
        this.vedioInit()
      }else{
        message.error(res.data.msg)
      }
    })
  }
  onChange = (current) => {
    this.setState({
      pageNum: current
    },()=> {
      this.vedioInit()
    })
  }
  getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
  
  componentDidMount() {
    let {vedioId} = this.props.location.state
    this.setState({vedioId},() => {
      this.vedioInit()
    })
  }
  showModal = () => {
    this.setState({
      modelTitle: '新增',
      visible: true
    })
  }
  render() {
		const {  vedioListData, columns, total, videoName, pageNum, modelTitle, bootVideo, visible } = this.state;
		const { getFieldDecorator } = this.props.form;
    
		return (
			<div className="boot-camp">
        <span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>视频详情</span>
				<Divider />
        <div style={{ display: 'flex', justifyContent: 'right', marginBottom: '20px' }}>
          <Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增</Button>
          <Button className='my-button-txt' onClick={() => {
						this.props.history.push('/bootCampet')
					}}>返回上一级</Button>
        </div>
        <Table
          dataSource={vedioListData}
          columns={columns}
          rowKey={record => record.id+''}
          rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
          pagination={false}
				/>
        <Pagination className="table-pagination" showTotal={total => `共 ${total} 条`} total={total} current={pageNum} showSizeChanger pageSizeOptions={['10', '20', '50', '100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} />
        <Modal
					getContainer={false}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
          width={680}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={this.handleOk}>
						<FormItem label={"名称"}>
							{getFieldDecorator('videoName', {
								rules: [{ required: true, message: '请输入视频名称!' },{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑'? videoName: ''
							})(
								<Input allowClear placeholder='请输入视频名称' />
							)}
						</FormItem>
            <FormItem label={"上传"}>
              {getFieldDecorator('bootVideo', {
                rules: [{ required: true, message: '请上传视频!', }],
                initialValue:(modelTitle === '编辑'&&bootVideo)? bootVideo: ''
              })(
                  <UploadVideo checksType={'pass'} getQiniuUrl={this.getQiniuUrl}></UploadVideo>
							  )
              }
            </FormItem>
          </Form>
        </Modal>
      </div>
    )
    }
}

export default Form.create()(BootVedio)